import { FormikHelpers, FormikValues } from 'formik';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { number, object } from 'yup';

import Botao from 'Component/Botao';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import Form, { Selecao } from 'Component/Form';
import { HoleriteUploadLista } from 'Component/Holerite';
import LayoutDefault from 'Component/Layout';
import { ANOS, MESES, TIPOS_HOLERITE } from 'View/constants';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const regras = object({
  mes: number().required('Obrigatório'),
  ano: number().required('Obrigatório'),
  tipo: number().required('Obrigatório'),
});

const Default = (): React.ReactElement => {
  const [tipo, setTipo] = useState<number>();
  const [mes, setMes] = useState<number>(DateTime.now().month);
  const [ano, setAno] = useState<number>(DateTime.now().year);

  const {
    data: { vinculos } = {},
    isFetching,
    isLoading,
  } = useRecuperarVinculosEmpregaticiosQuery(
    {
      contain: ['Usuarios', 'Empresas'],
      limit: 200,
      options: { status: 1 },
      sort: 'Usuarios.nome',
    },
    {
      skip: !mes || !ano || !tipo,
    }
  );

  const filtrar = (
    dados: { mes: number; ano: number; tipo: number },
    form: FormikHelpers<FormikValues>
  ) => {
    setMes(dados.mes);
    setAno(dados.ano);
    setTipo(dados.tipo);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Holerites em lote"
        descricao="Importe em lote o holerite dos funcionários"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
        inicial={{
          mes: DateTime.now().month,
          ano: DateTime.now().year,
        }}
      >
        <div className="row justify-content-center">
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Selecao name="tipo" opcoes={TIPOS_HOLERITE} padrao="Tipo" />
              <Selecao
                name="mes"
                opcoes={MESES}
                aoAtualizar={setMes}
                padrao="Mês"
              />
              <Selecao
                name="ano"
                opcoes={ANOS}
                aoAtualizar={setAno}
                padrao="Ano"
              />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <React.Fragment>
        {mes && ano && tipo && vinculos && vinculos.length > 0 && (
          <div className="bg-white shadow-sm rounded">
            {vinculos?.map((folha) => (
              <HoleriteUploadLista
                key={`${folha.id}-${folha.modificado}`}
                dados={folha}
                mes={mes}
                ano={ano}
                tipo={tipo}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    </LayoutDefault>
  );
};

export default Default;
